export const projects = [
  { id: 1, label: 'Classroom' },
  { id: 2, label: 'Foundation' },
  { id: 3, label: 'Little Genie' },
  { id: 4, label: 'Speak Pro' },
];
